import styled from 'styled-components';

export const CircleChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-width : 56px;
  min-height : 56px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledSVG = styled.svg`
  transform: rotate(-90deg);
  width: 100%;
  height: 100%;
`;

export const CenterText = styled.text`
  font-weight: semibold;
`;
